import { decryptedValue } from "common/utility";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import TableContainerV1 from "components/Common/TableContainerV1";
import { getCommercialsList } from "http/fundLync/entityAndAddress.helper";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";


const TableActionsComponent = (props) =>{
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  const navigateToEditRoles = (id) => {
    navigate(`/${user.roleName}/add-commercial?id=${id}`);
  };
  return (
    <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    navigateToEditRoles(props.id);
                  }}
                >
                  <i
                    className="mdi mdi-pencil font-size-16 text-success me-1"
                    id="edittooltip"
                  ></i>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
  )
}



const Commercials = () => {
  //meta title
  document.title = "List Commercials | FundLync";

  const navigate = useNavigate();

  const [commercialsList, setCommercialsList] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");

  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action","integrationFees","platformCharges","syndicationFees","selfFinanaces"],
  });
  



  useEffect(() => {
    loadCommercialList();
  }, []);

  const loadCommercialList = async (params = null) => {
    const res = await getCommercialsList(params);
    const data = res?.data?.data;
    setPagination({pageIndex:res.data?.currentPage, pageCount:res.data?.totalPages,totalRecords:res.data?.totalItems})  
    if(data){
      setCommercialsList(data);
    }else{
      setCommercialsList([]);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        },
      },
      {
        Header: "PAN",
        accessor: "pan",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        },
      },
      {
        Header: "Entity Name",
        accessor: "entityName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        },
      },
      {
        Header: "Email Id",
        accessor: "email",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        },
      },
      {
        Header: "Fin Weave Integration Fees",
        accessor: "integrationFees",
        filterable: true,
        Cell: (cellProps) => {
          let value = cellProps?.row?.original?.commercials[0]?.integrationFees
          if(value?.Type == 'Flat'){
            return '₹'+' '+value?.Value  || 'NA';
          }else{
            return (value?.Value ? value.Value + '%' : 'NA');
          }
        },
      },
      {
        Header: "Platform Charges",
        accessor: "platformCharges",
        filterable: true,
        Cell: (cellProps) => {
          let value = cellProps?.row?.original?.commercials[0]?.platformCharges
          if(value?.Type == 'Flat'){
            return '₹'+' '+value?.Value || 'NA';
          }else{
            return (value?.Value ? value.Value + '%' : 'NA');
          }
        },
      },
      {
        Header: "Syndication Fees",
        accessor: "syndicationFees",
        filterable: true,
        Cell: (cellProps) => {
          let value = cellProps?.row?.original?.commercials[0]?.syndicationFees
          if(value?.Type == 'Flat'){
            return '₹'+' '+value?.Value  || 'NA';
          }else{
            return (value?.Value ? value.Value + '%' : 'NA');
          }
        },
      },
      {
        Header: "Self Finances / Early Payment",
        accessor: "selfFinanaces",
        filterable: true,
        Cell: (cellProps) => {
          let value = cellProps?.row?.original?.commercials[0]?.selfFinanaces
          if (value && value.Type === 'Flat') {
            return '₹'+' '+value?.Value  || 'NA';
          } else {
           return (value?.Value ? value.Value + '%' : 'NA');
          }
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return TableActionsComponent(rowData);
        },
      },
    ],
    []
  );

  const handlePageChange = (
    page,
    pageSize,
    searchKey,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
    loadCommercialList({ page, limit: pageSize, searchKey, columnName, sortingOrder })
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    setSearchValue(value);
    handlePageChange(1, pageSize, value);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "");
  };

  const handleCustomerClicks = () => {
    navigate(`/${user.roleName}/add-commercial`);
  };

  const buttonSection = (
    <div className="text-sm-end">
      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={handleCustomerClicks}
      >
        <i className="mdi mdi-plus me-1" />
        {'New Commercial'}
      </Button>
    </div>
  );

  return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="COMMERCIALS LIST" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainerV1
                    columns={columns}
                    data={commercialsList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    customSection={buttonSection}
                    sortOptions={sortingOptions}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
  );
};

export default Commercials;
